import { useEffect } from "react";
import { useParams } from "react-router-dom";

const CREATOR_URL = "https://creator.applaby.com";

export default function ReferralRedirect() {
	const { code } = useParams();

	useEffect(() => {
		if (code) {
			localStorage.setItem("referralCode", code);
		}
		window.location.href = `${CREATOR_URL}/?ref=${code || ""}`;
	}, [code]);

	return null;
}
